import { memo, useCallback } from 'react';
import {
  Box,
  Image,
  NamespacedImageKeys,
  PressableOverlay,
  useHover,
} from '@betty/moonlight';
import { TopSlotProviderProps } from './TopSlotProvider.types';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { selectSubProviderById } from '../../../../state';

function TopSlotProvider({ id, ...rest }: TopSlotProviderProps) {
  const { isHovered, ...hoverTriggers } = useHover();

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const subProviderName = selectSubProviderById(id);
  const subproviderImage =
    `games.${id}` as keyof RegisteredImages['games'] as NamespacedImageKeys;

  const onProviderPress = useCallback(() => {
    navigation.navigate('ProviderGamesScreen', { subProviderName });
  }, [subProviderName, navigation]);

  return (
    <Box
      minWidth={104}
      height={67}
      alignItems="center"
      justifyContent="center"
      borderRadius="radius-300"
      backgroundColor={
        isHovered ? 'primaryBackgroundHover' : 'primaryBackground'
      }
      padding={'space-400'}
      {...rest}
    >
      <Image name={subproviderImage} width={'100%'} height={'100%'} />
      <PressableOverlay {...hoverTriggers} onPress={onProviderPress} />
    </Box>
  );
}

export default memo(TopSlotProvider);
